import { UserListQueryMode, UserListQueryModeInstance } from './../../model/shared/user/user';
import { ReqPaymentRate } from './../../model/shared/transaction/payment';
import { TxnSubInfoResponse } from 'app/response/txnsubinforesult';
import { ExpiredSearch } from './../../view-model/admin/expiredmanage';
import {Payment} from '../../model/shared/transaction/payment';
import { PayoutAccValidate, Transaction, TransactionDetail, TxnDepositInfo } from '../../model/shared/transaction/transaction';
import {TransactionSearch} from '../../model/shared/transaction/transactionsearch';
import {User, Agent, Customer} from '../../model/shared/user/user';
import {UserSearch} from '../../model/shared/user/usersearch';
import {AccountValidation} from '../../model/shared/user/validation';
import {BranchDetailResult} from '../../response/branchdetailresult';
import {HomeResult, LLPHomeResult} from '../../response/homeresult';
import {BaseResponse} from '../../response/internal/baseresponse';
import {PayoutAgentList, AgentListResult, PayoutBranchListResult, PayoutBankListResult} from '../../response/internal/list/agentlistresult';
import {PayoutCountryListResult} from '../../response/internal/list/payoutcountrylist';
import {LoginResult} from '../../response/loginresult';
import {PartnerDetailResult} from '../../response/partnerdetailresult';
import {TransactionApproveResult} from '../../response/transactionapproveresult';
import {TransactionCancelResult} from '../../response/transactioncancelresult';
import {TransactionDetailResult} from '../../response/transactiondetailresult';
import {TransactionListResult} from '../../response/transactionlistresult';
import {TransactionRateResult} from '../../response/transactionrateresult';
import {TransactionSaveResult} from '../../response/transactionsaveresult';
import {UserDetailResult} from '../../response/userdetailresult';
import {UserListResult, ReceiverListResult, CustomerListResult} from '../../response/userlistresult';
import {UserModifyResult, UserValidateMobile, UserValidateMobileResult, UserVerifyMobile} from '../../response/usermodifyresult';
import {UserRegisterResult} from '../../response/userregistresult';
import {UserRemittanceResult} from '../../response/userremittanceresult';
import {UserStatisticsResult} from '../../response/userstatisticsresult';
import {Login} from '../../view-model/common/login';
import {TransactionApprove} from '../../view-model/agent/transactionapprove';
import {TransactionCancel} from '../../view-model/agent/transactioncancel';
import {PasswordChange} from '../../view-model/common/passwordchange';
import {UserTransactionList} from '../../model/shared/transaction/transaction';
import {UserTransactionListResult} from '../../response/usertransactionlistresult';
import {AddressSearchResult} from '../../response/addressresult';
import {UserKycCountResponse} from '../../response/userkyccount';


import {Api} from '../config/api';
import {RequestService} from './request.service';
import {SessionService} from './session.service';
import {UserService} from './user.service';
import {Injectable, OnDestroy} from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {Subscription} from 'rxjs/Subscription';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import { LoginHistorySearch } from '../../model/shared/admin/loginhistorysearch';
import { BankDepositSearch } from '../../model/shared/bank/depositsearch';
import { DepositSlipInfo } from '../../response/depositslipresult';
import { BankBranchListResult } from 'app/response/bankbranchresult';
import { ReqReceiverList } from 'app/response/internal/list/userlist';
import { ADMPartnersResult } from 'app/response/admin/admpartnersresult';
import { TxnValidResult } from 'app/response/txnvalidresult';
import { PartnerGroupResult } from 'app/response/partnergroupresult';
import { CustomerSnsInfoResult } from 'app/response/customersnsresult';


@Injectable()
export class AgentService implements OnDestroy {

  _options: RequestOptions;
  _isLogin: Boolean = this.sessionService.getAgentLogin();
  _loginSubscription: Subject<boolean>;
  _agentInfo: User;
  constructor(
    public request: RequestService,
    protected _user: UserService,
    public sessionService: SessionService) {
    this._options = new RequestOptions();
    this._options.headers = _user._options.headers;
    this._loginSubscription = sessionService.loginChange;
    this._loginSubscription.subscribe((value) => {
      this._isLogin = value;
    });
  }

  sessionInit() {
    this.sessionService.clear();
    this.request._raw().get(Api.Common.sessionInit).subscribe();
  }

  login(loginInfo: Login): Observable<LoginResult> {
    return this.request.postBasic(Api.Agent.Login, this._options, loginInfo, LoginResult);
  }

  mypage(login: User): Observable<LoginResult> {
    return this.request.postBasic(Api.Agent.MyPage, this._options, login, LoginResult);
  }

  mypageupdate(agent: Agent): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.MyPageUpdate, this._options, agent, BaseResponse);
  }
  passwordupdate(password: PasswordChange): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.PasswordUpdate, this._options, password, BaseResponse);
  }

  home(): Observable<HomeResult> {
    return this.request.getBasic(Api.Agent.Home, this._options, HomeResult);
  }

  user(option: UserSearch): Observable<UserListResult> {
    return this.request.postBasic(Api.Agent.User, this._options, option, UserListResult);
  }

  userdetail(id: string, querymode: UserListQueryMode = UserListQueryMode.Full): Observable<UserDetailResult> {
    return this.request.getBasic(Api.Agent.User + '/' + id + '/detail'+ '?query=' + UserListQueryModeInstance.conv(querymode), this._options, UserDetailResult);
  }

  userregister(user: User): Observable<UserRegisterResult> {
    return this.request.postBasic(Api.Agent.UserRegister, this._options, user, UserRegisterResult);
  }

  userblock(user: User): Observable<UserValidateMobileResult> {
    return this.request.postBasic(Api.Admin.CustomerBlock, this._options, user, UserValidateMobileResult);
  }

  usercheck(user: User): Observable<UserRegisterResult> {
    return this.request.postBasic(Api.Agent.UserCheck, this._options, user, UserRegisterResult);
  }

  usermodify(user: User): Observable<UserModifyResult> {
    return this.request.postBasic(Api.Agent.UserModify, this._options, user, UserModifyResult);
  }

  usermodifyvalid(user: User): Observable<UserModifyResult> {
    return this.request.postBasic(Api.Agent.UserModifyValid, this._options, user, UserModifyResult);
  }

  uservalidatemobile(modify: UserValidateMobile): Observable<UserValidateMobileResult> {
    return this.request.postBasic(Api.Agent.UserValidateMobile, this._options, modify, UserValidateMobileResult);
  }

  userverifymobile(modify: UserVerifyMobile): Observable<UserValidateMobileResult> {
    return this.request.postBasic(Api.Agent.UserVerifyMobile, this._options, modify, UserValidateMobileResult);
  }

  userstatistics(id: string, year: number, type: string): Observable<UserStatisticsResult> {
    return this.request.getBasic(Api.Agent.UserStatistics(id, year, type), this._options, UserStatisticsResult);
  }

  userremittance(id: string): Observable<UserRemittanceResult> {
    return this.request.getBasic(Api.Agent.UserRemittance(id), this._options, UserRemittanceResult);
  }

  transaction(option: TransactionSearch): Observable<TransactionListResult> {
    return this.request.postBasic(Api.Agent.Transaction, this._options, option, TransactionListResult);
  }

  transactiondetail(id: string): Observable<TransactionDetailResult> {
    return this.request.getBasic(Api.Agent.TransactionDetail + '/' + id, this._options, TransactionDetailResult);
  };

  transactioncancel(cancel: TransactionCancel): Observable<TransactionCancelResult> {
    return this.request.postBasic(Api.Agent.TransactionCancel, this._options, cancel, TransactionCancelResult);
  }

  transactionapprove(approve: TransactionApprove): Observable<TransactionApproveResult> {
    return this.request.postBasic(Api.Agent.TransactionApprove, this._options, approve, TransactionApproveResult);
  }

  transactionsender(option: UserSearch): Observable<CustomerListResult> {
    return this.request.postBasic(Api.Agent.TransactionSender, this._options, option, CustomerListResult);
  }

  transactionreceiver(id: string): Observable<ReceiverListResult> {
    return this.request.getBasic(Api.Agent.TransactionReceiver(id), this._options, ReceiverListResult);
  }

  transactioncountry(): Observable<PayoutCountryListResult> {
    return this.request.getCacheMode(Api.Agent.TrnasactionCountry, this._options, PayoutCountryListResult, 60);
  }

  transactionbankbytype(partner: string, payout_type: string): Observable<PayoutBankListResult> {
    return this.request.getCacheMode(Api.Agent.TrnasactionPayoutBankByType(partner, payout_type), this._options, PayoutBankListResult);
  }

  transactionbranchbytype(partner: string, type: string): Observable<PayoutBranchListResult> {
    return this.request.getCacheMode(Api.Agent.TransactionPayoutBranchByType(partner, type), this._options, PayoutBranchListResult);
  }

  transactionrate(payment: ReqPaymentRate): Observable<TransactionRateResult> {
    return this.request.postBasic(Api.Agent.TransactionRate, this._options, payment, TransactionRateResult);
  }

  transactionsave(transaction: Transaction): Observable<TransactionSaveResult> {
    return this.request.postBasic(Api.Agent.TransactionSave, this._options, transaction, TransactionSaveResult);
  }

  transactionvalid(transaction: Transaction): Observable<TxnValidResult> {
    return this.request.postBasic(Api.Agent.TransactionValid, this._options, transaction, TxnValidResult);
  }

  partnerdetail(partner_id: string): Observable<PartnerDetailResult> {
    return this.request.getBasic(Api.Agent.PartnerDetail(partner_id), this._options, PartnerDetailResult);
  }

  customerblock(customer: Customer): Observable<UserValidateMobileResult> {
    return this.request.postBasic(Api.Admin.CustomerBlock, this._options, customer, UserValidateMobileResult);
  }
  branchdetail(branch_code: string): Observable<BranchDetailResult> {
    return this.request.getBasic(Api.Agent.BranchDetail(branch_code), this._options, BranchDetailResult);
  }

  amlcheck(user: User): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.AMLCheck, this._options, user, BaseResponse);
  }

  getUserTransactionList(id: string, year: string, type: string): Observable<UserTransactionListResult> {
    return this.request.getBasic(Api.Agent.UserTransactionList + '/' + id + '/' + year + '/' + type, this._options, UserTransactionList);
  }

  getAddressStateList(): Observable<BaseResponse> {
    return this.request.getCacheMode(Api.Agent.KYCAddressState, this._options, BaseResponse, 60);
  }

  searchAddressByZipcode(zipcode: string): Observable<AddressSearchResult> {
    return this.request.getBasic(Api.Admin.KYCSearchAddressByZipCode(zipcode), this._options, AddressSearchResult);
  }

  ngOnDestroy() {
    this._loginSubscription.unsubscribe();
  }

  getDepositAccList(): Observable<BaseResponse> {
    return this.request.getCacheMode(Api.Agent.DepositAccountList, this._options, BaseResponse, 60);
  }

  getDepositBranches(): Observable<BankBranchListResult> {
    return this.request.getCacheMode(Api.Agent.DepositBranches, this._options, BankBranchListResult, 60);
  }

  saveDepositAcc(txnInfo: TxnDepositInfo): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.DepositAccountSave, this._options, txnInfo, BaseResponse);
  }

  userNationalityList(): Observable<PayoutCountryListResult> {
    return this.request.getCacheMode(Api.Agent.UserNationalityList, this._options, PayoutCountryListResult, 2);
  }

  getKycCount(agent_idx): Observable<UserKycCountResponse> {
    return this.request.getBasic(Api.Agent.CustomerKycCount + '?agent=' + agent_idx, this._options, UserKycCountResponse);
  }

  server_version(): Observable<BaseResponse> {
    return this.request.getCacheMode(Api.Admin.Version, this._options, BaseResponse, 60);
  }

  resetFailedCount(id: string): Observable<BaseResponse> {
    return this.request.getBasic(Api.Agent.ResetFailedCount + '/' + id, this._options, BaseResponse);
  }

  userfiledata(idx: number): Observable<BaseResponse> {
    return this.request.getBasic(Api.Agent.UserFileData + idx + '/data', this._options, BaseResponse);
  }

  getUserCoi(id: string, coi_type: string): Observable<BaseResponse> {
    return this.request.getBasic(Api.Agent.UserCoi + '/' + id + '/' + coi_type, this._options, BaseResponse);
  }

  accountValidation(transaction: PayoutAccValidate): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.AccountValidation, this._options, transaction, BaseResponse);
  }
  
  getbankdeposithistory(options: BankDepositSearch): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.GetBankDepositHistory, this._options, options, BaseResponse);
  }

  updatebankdeposithistory(): Observable<BaseResponse> {
    return this.request.getNoWait(Api.Agent.UpdateBankDepositHistory,  this._options, BaseResponse);
  }

  getDepositSlip(slipInfo: DepositSlipInfo): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.GetDepositSlipInfo, this._options, slipInfo, BaseResponse);
  }

  getpayoutbranches(partner: string, bank_code: string, payout_type: string): Observable<PayoutBranchListResult> {
    const reqBody = new Object();
    reqBody['partner_id'] = partner;
    reqBody['bank_code'] = bank_code;
    reqBody['payout_type'] = payout_type;
    return this.request.postBasic(Api.Agent.GetPayoutBranches, this._options, reqBody, PayoutBranchListResult);
  }

  /* login history */
  getloginhistory(options: LoginHistorySearch): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.GetLoginHistory, this._options, options, BaseResponse);
  }

  /* expired customers */
  getexpiredcustomerlist(search: ExpiredSearch): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.ExpiredCustomerList, this._options, search, BaseResponse);
  }

  getServiceListByPartner(partner_id: string): Observable<BaseResponse> {
    return this.request.getBasic(Api.Agent.GetServiceListByPartner(partner_id), this._options, BaseResponse);
  }

  gettxninfolist(type: string): Observable<TxnSubInfoResponse> {
    return this.request.getCacheMode(Api.Agent.GetTxnInfoList(type), this._options, TxnSubInfoResponse, 60);
  }

  getexternalpartners(): Observable<ADMPartnersResult> {
    return this.request.getBasic(Api.Agent.GetExternalPartners, this._options, ADMPartnersResult);
  }

  gettxninfofulllist(): Observable<BaseResponse> {
    return this.request.getCacheMode(Api.Agent.GetTxnInfoFullList, this._options, BaseResponse, 10);
  }

  receiverlist(search: UserSearch): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.GetReceiverList, this._options, search, BaseResponse);
  }

  deleteReceiver(index: string): Observable<BaseResponse> {
    return this.request.getBasic(Api.Agent.DeleteReceiver(index), this._options, BaseResponse);
  }

  saveBeneficiaryList(list: ReqReceiverList): Observable<BaseResponse> {
    return this.request.postBasic(Api.Agent.SaveBeneficiaryList, this._options, list, BaseResponse);
  }

  payoutpartnergrouplist(): Observable<PartnerGroupResult> {
    return this.request.getBasic(Api.Agent.PayoutPartnerGroupList, this._options, PartnerGroupResult);
  }

  getCustomerSnsInfo(agentId: string): Observable<CustomerSnsInfoResult>{
    return this.request.getBasic(Api.Agent.getCustomerSnsInfo(agentId), this._options, CustomerSnsInfoResult);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/agent.service.ts